import { render } from "./MainDetalProduct.vue?vue&type=template&id=686c6ecf&scoped=true"
import script from "./MainDetalProduct.vue?vue&type=script&lang=js"
export * from "./MainDetalProduct.vue?vue&type=script&lang=js"

import "./MainDetalProduct.vue?vue&type=style&index=0&id=686c6ecf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686c6ecf"]])

export default __exports__